const isMainButtonClick = (e: MouseEvent) => {
  return e.button == 0 && !e.altKey && !e.ctrlKey && !e.metaKey
}

export default isMainButtonClick
